import {
  Calendar,
  Phone,
  MapPin,
  Clock,
  Star,
  Award,
  Heart,
  Shield,
  Building2,
  Package,
  Stethoscope,
  PlusCircle,
  Baby,
  Bone,
  Brain,
  Microscope,
  ChevronRight,
  Download,
  CheckCircle,
  Trophy,
  BadgeIcon as Certificate,
  User,
  ArrowRight,
} from "lucide-react"
import { AwardCard } from "../award-card"
import { Badge } from "../ui/badge"



export default function Awardswidget() {
  return (
         <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="flex flex-col items-center mb-10 text-center">
              <Badge className="mb-2">Recognition</Badge>
              <h2 className="mb-4 text-3xl font-bold md:text-4xl">Awards & Accreditations</h2>
              <p className="max-w-2xl text-muted-foreground">
                Pranaam Hospitals has been recognized for excellence in healthcare services and patient care.
              </p>
            </div>

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
              <AwardCard
                icon={<Award className="w-10 h-10 text-primary" />}
                title="NABH Accreditation"
                description="National Accreditation Board for Hospitals & Healthcare Providers"
                year="2023"
              />
              <AwardCard
                icon={<Trophy className="w-10 h-10 text-primary" />}
                title="Best Multi-Specialty Hospital"
                description="Healthcare Excellence Awards"
                year="2022"
              />
              <AwardCard
                icon={<Shield className="w-10 h-10 text-primary" />}
                title="Patient Safety Excellence"
                description="Medical Quality Assurance Council"
                year="2023"
              />
              <AwardCard
                icon={<Certificate className="w-10 h-10 text-primary" />}
                title="Healthcare Innovation Award"
                description="Medical Technology Association"
                year="2021"
              />
            </div>
          </div>
        </section>
    
  );
}

 